import type { ClickedImageType } from './MyImage';
import styles from './imageModal.module.css';

type ImageModalProps = {
  clickedImage?: ClickedImageType;
  onClick?: () => void;
  onClose?: () => void;
  fullImageSrc?: string;
};

export const ImageModal = ({ clickedImage, onClose, onClick, fullImageSrc }: ImageModalProps) => {
  if (!clickedImage) return;
  const { uncompressedImageSrc, src, description, name } = clickedImage;

  return (
    <div
      className={styles.modal}
      onClick={onClose}
      onKeyUp={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClose?.();
        }
      }}
    >
      <div className={styles.modalContent}>
        <img
          src={src}
          alt={description}
          onClick={(event) => {
            event.stopPropagation();
            onClick?.();
          }}
          onKeyUp={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.stopPropagation();
              onClick?.();
            }
          }}
        />
        <h2
          className={styles.imageDescription}
          onClick={() => window.open(uncompressedImageSrc, '_blank')}
          onKeyUp={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              window.open(fullImageSrc, '_blank');
            }
          }}
        >
          {name === description ? name : description}
        </h2>
      </div>
    </div>
  );
};
